
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonService } from 'src/app/core/services/common-service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import {
  customerProposalDetailsModal, RejectProposal, getOTPForCustomerProposalAcceptanceModel,
  validateOTPForCustomerProposalAcceptanceModel, CustomerProposalListModal,
  EditCustomerProposalSaveModal
} from 'src/app/core/models/customerProposalDetails';
import { customerProposalService } from 'src/app/core/services/customerProposal.service.';
import { CreateQuoteService } from 'src/app/core/services/create-quote-service';
import { fakeAsync } from '@angular/core/testing';
import { PaymentPendingService } from 'src/app/core/services/payment-pending.service';
import { updateProposalToPolicyModel } from 'src/app/core/models/updateProposalToPolicy';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NewQuoteService } from 'src/app/core/services/new-quote.service';
import { timeoutWith } from 'rxjs/operators';
import { DatePipe, formatDate } from '@angular/common';
import { NgForm } from '@angular/forms';
import JSZip from 'jszip';
import { CommonMethodService } from 'src/app/core/services/common.method-service';
import product_related from 'src/assets/FAQs/marine-customer_faqs/product_related.json';
import general from 'src/assets/FAQs/marine-customer_faqs/general.json';
import { FinancierDetailsComponent } from 'src/app/shared/components/financier-details/financier-details.component';
import { UploadedFileObj } from 'src/app/core/models/uploadedDocumentDetails';
import { NewProposalService } from 'src/app/core/services/new-proposal.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { PreviousPolicyDetailsComponent } from 'src/app/module/new-proposal/previous-policy-details/previous-policy-details.component';



declare var $: any;

@Component({
  selector: 'app-marine-customer-proposal',
  templateUrl: './marine-customer-proposal.component.html',
  styleUrls: ['./marine-customer-proposal.component.css'],
  standalone: false
})
export class MarineCustomerProposalComponent implements OnInit {
  refactoredJsonObj: any = [];
  previousPolicyData = [];
  token: any = '';
  searchText: any;
  filtersLoaded: Promise<boolean>;
  dataToDownloadBrochure = {
    productCode: '',
    documentType: 'BROCHURE'
  };
  @ViewChild('validatePrevPolicyDetailsComponent', { static: true, read: PreviousPolicyDetailsComponent }) private PreviousPolicyDetailsComponent: PreviousPolicyDetailsComponent;
  @ViewChild('validateFinancierDetailsComponentForm', { static: true, read: FinancierDetailsComponent }) private financierDetailsComponent: FinancierDetailsComponent;
  financierDetailsFormValid: boolean;
  dataToDownloadPolicyWordings = { productCode: '', documentType: 'POLICYWORDINGS' }
  generalFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = product_related;
  generalallFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = general;

  customerRejectCommentsDetails = {
    comment: '',
    userCode: '',
    createdBy: '',
    time: '',
  }
  ifProposalRejected = false;
  ifProposalAccepted = false;
  isEditCustomerProposal = false;
  isCustomerProposalMakePayment = false;
  premiumBreakUpAddonCovglist = [
    ['Terrorism Premium', null],
    ['Terrorism for Add-on  Premium', null],
    ['Forest Fire Premium', null],
    ['Architects, Surveyors Premium', null],
    ['Loss of Rent Premium', null],
    ['Additional Expense of Rent Premium', null],
    ['Removal of Debris Premium', null],
    ['Impact Damage Premium', null],
    ['Omission Premium', null]
  ];
  premiumBreakUpBasicCovglist = [
    ['Basic Premium', null],
    ['STFI Premium', null],
    ['Earthquake Premium', null]
  ]
  rejectCustomerProposal = new RejectProposal();
  tempProposalNumber: string;
  acceptProposalOtpResponse: any;
  dataForPdf: any;
  blob: Blob;
  isOTPInvalid: boolean;
  isOTPTimedOut: boolean;
  paymentResponse: any;
  financierList = [];
  invoiceList = [];
  salutationList: any;
  customerTypeList: any;
  masterDataForQuote: any;
  agreementData: any;
  customerProposalTotalResponse: any;
  customerProposalRateList: any;
  policyStartDate: any;
  DateofBirthEditProposal: any;
  isCheckSelected = false;
  isCustomerProposalMakePaymentSuccess: boolean;
  customerProposalEditParams: any = {

  };
  coveragesList = [];
  coverageItem = {
    coverageName: '',
    sumInsured: '',
    indemnityPeriod: ''
  };
  saveEditCustomerProposalList = new EditCustomerProposalSaveModal();
  customerProposalList = new CustomerProposalListModal();
  customerProposalEdit = new CustomerProposalListModal();
  submitted = false;
  isDobInvalid: boolean;
  dobFutureDate: boolean;
  isMobilenumber2InValid: boolean;
  isMobilenumberInValid: boolean;
  isAlEmailIdInValid: boolean;
  isEmailIdInValid: boolean;
  isPolicyStartDate: boolean;
  isPaymentByAgentBehalfIndicator: any;
  isPinCodeInvalid: boolean;
  PincodeMasterData: any;
  PinCodeList: any;
  promise: any;
  ifRequestAgentToPayment: boolean;
  isPaymentBehalfCustomer: boolean;
  isCustomerRejectionCommentsInvalid: boolean;
  emptyFieldError: boolean;
  selectedType: any;
  isInclusionofFinancierChecked: any;
  isAnyOtherNilEndorsementChecked: boolean;
  isChangeinClientDetailsChecked: boolean;
  endorsementType: any;
  disableAllEn = false;
  isEndorsement = false;
  newPolicyDetails: string;
  oldPolicyDetails: string;
  premiumAfterCalculateNull: boolean;
  masterDataForMarine: any;
  lineOfBusinessCode: string = '';
  businessValidations: any = {};
  policyEndDate: any;

  lobAndProductList = {};
  lobList: any;
  productData: any;
  formatblAwbLRrrCnDate: any;
  isCustomerTypeInvalid: boolean;


  constructor(private newProposalService: NewProposalService, public commonService: CommonService, public datepipe: DatePipe, private newQuoteService: NewQuoteService, private router: Router,
    private route: ActivatedRoute, private customerProposalService: customerProposalService, private createQuoteService: CreateQuoteService,
    private paymentService: PaymentPendingService, private notifyService: NotificationService, public commonMethodService: CommonMethodService, private loaderService: LoaderService) { }
  customerDetailsList: any;
  customerDetailsForGetOtpParams = new getOTPForCustomerProposalAcceptanceModel();
  customerDetailsForValidateOtpParams = new validateOTPForCustomerProposalAcceptanceModel();
  proposalsToPolicyParams = new updateProposalToPolicyModel();
  searchParams = {
    imdCode: '',
    token: this.token,
  };

  inputForPayment = {
    paymentDetails: {
      transactionId: '94204CE9030820162402E1DK',
      amount: 0,
      productInfo: '',
      firstName: '',
      emailAddress: '',
      phoneNumber: '',
      proposalNo: '',
      activityName: 'customer proposal'
    }
  };
  proposalInput = {
    proposalNumber: ''
  };
  productCode = '3413';
  customer: any;
  maskedMobileNumber: string;
  setRotate0 = true;
  setRotate1 = true;
  setRotate2 = true;
  setRotate3 = true;
  setRotate4 = true;
  setRotate5 = true;
  setRotate6 = true;
  setRotate7 = true;
  setRotate8 = true;
  ngOnInit() {
    //console.log(this.generalFAQs);
    this.route.queryParams.subscribe(params => {
      this.tempProposalNumber = params.proposalNo;
      this.isEndorsement = this.tempProposalNumber.includes('EN') ? true : false;
      this.proposalInput.proposalNumber = this.tempProposalNumber;
      this.getUploadedDocuments(params.proposalNo);
      // this.commonService.getLineofBusiness().subscribe((res) => {
      //   this.lobList = res;
      //   this.route.queryParams.subscribe(params => {
      //     if (Object.keys(params).length != 0) {
      //       this.lineOfBusinessCode = "34";
      //       this.productCode = '3413';
      //       this.getMasterDataForMarine();
      //       this.lobAndProductList = this.lobList.find((lob) => lob.lobCode == this.lineOfBusinessCode);
      //     }
      //   });
      // });

      this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
        this.isPaymentByAgentBehalfIndicator = res;
      });
      if (Object.keys(params).length > 1) {
        this.paymentResponse = params;
        this.updateTransactionDetailsAfterPayment();

      }
    });
    // this.getLOBs()
    // this.editCustomerproposal()
    this.customerProposal();
    this.agreementTypeData();
    this.getCustomerTypeList();
    this.getMasterDataForMarine();
    setTimeout(() => {
      this.tooltipInit();
    }, 2000);

    setTimeout(() => {
      this.tooltipInit();
    }, 6000);

    setTimeout(() => {
      this.tooltipInit();
    }, 10000);

  }

  clearSearchText() {
    this.searchText = '';
  }

  isfinancierDetailsFormValid(formValid: any) {
    this.financierDetailsFormValid = formValid;
  }

  rotateIcon(iconId: number) {
    switch (iconId) {
      case 0:
        this.setRotate0 = !this.setRotate0;
        break;
      case 1:
        this.setRotate1 = !this.setRotate1;
        break;
      case 2:
        this.setRotate2 = !this.setRotate2;
        break;
      case 3:
        this.setRotate3 = !this.setRotate3;
        break;
      case 4:
        this.setRotate4 = !this.setRotate4;
        break;
      case 5:
        this.setRotate5 = !this.setRotate5;
        break;
      case 6:
        this.setRotate6 = !this.setRotate6;
        break;
      case 7:
        this.setRotate7 = !this.setRotate7;
        break;
      case 8:
        this.setRotate8 = !this.setRotate8;
        break;

    }
  }
  tooltipInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  downloadCustomerProposalDataBrochure() {
    this.dataToDownloadBrochure.productCode = '34';
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadBrochure).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'Brochure.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  downloadCustomerPolicyWordings() {
    this.dataToDownloadPolicyWordings.productCode = this.customerDetailsList.ProductCode;
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadPolicyWordings).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'PolicyWordings.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  customerProposal() {
    this.ifRequestAgentToPayment = false;
    this.searchParams.imdCode = this.commonService.getUserName();
    this.searchParams.token = this.token;
    this.customerProposalService.getMarineCustomerProposalDetails(this.tempProposalNumber + '').subscribe((res: any) => {
      this.filtersLoaded = Promise.resolve(true);
      this.customerDetailsList = res.inputRequest;
      this.customerProposalTotalResponse = res;

      if (this.customerDetailsList.typeOfBusiness == 'Roll Over') {
        this.previousPolicyData = this.customerDetailsList.PASTPOLICY['PASTPOLICYDETAILS'];
        if (!('conditions' in this.customerProposalTotalResponse)) {
          this.customerProposalTotalResponse.conditions = [];
        }
      }
      if ('premiumData' in this.customerProposalTotalResponse) {
        this.premiumAfterCalculateNull = true;
        this.mapPremiumBreakUpForAddonCovers(res.premiumData);
        this.mapPremiumBreakUpForBasicCovers(res.premiumData);
      } else {
        this.premiumAfterCalculateNull = false;
      }
      this.mapCoverages();
      this.customerTypeMappingForMarine();
      localStorage.setItem('gc_proposalNo', res.gcProposalNumber);
      localStorage.setItem('CustomerID', res.customerId);
      localStorage.setItem('ProposalNumber', res.proposalNumber);
      this.maskedMobileNumber = this.customerDetailsList.customerDetails.mobileNumber.toString().replace(/^(\d{3})\d(?=\d{3})|\d(?=\d{3})/g, '$1*');
      if ('oldPolicyDetails' in this.customerProposalTotalResponse) {
        this.newPolicyDetails = this.customerProposalTotalResponse.inputRequest.InputXML;
        this.oldPolicyDetails = this.customerProposalTotalResponse.oldPolicyDetails.inputRequest.InputXML;
        this.commonMethodService.filterAndAddBothValues(((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.newPolicyDetails)).flat())).flat(Infinity),
          ((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.oldPolicyDetails)).flat())).flat(Infinity));
      }

      //console.log(this.customerProposalTotalResponse);
      if (this.customerProposalTotalResponse.status == 'Rejected by Customer' || this.customerProposalTotalResponse.status == 'EN Rejected by customer') {
        this.ifProposalRejected = true;
      } else if
        (this.customerProposalTotalResponse.status == 'Payment Pending' || this.customerProposalTotalResponse.status == 'EN Pending Payment') {
        this.ifProposalAccepted = true;
      } else if (this.customerProposalTotalResponse.status == '') {
        this.isCustomerProposalMakePaymentSuccess = true;
      }
      if (this.customerProposalTotalResponse.isAgentPayment == true) {
        this.ifRequestAgentToPayment = true;
      } else {
        this.ifRequestAgentToPayment = false;
      }
      if (this.customerProposalTotalResponse.isPaymentBehalfCustomer) {
        this.isPaymentBehalfCustomer = false;
      } else {
        this.isPaymentBehalfCustomer = true;
      }
      if (this.ifProposalAccepted == true || this.customerProposalTotalResponse.status == 'In force') {
        this.isCheckSelected = true;
      }
      this.tooltipInit();
      // this.formatblAwbLRrrCnDate = this.customerDetailsList.miscellaneousDetails.blAwbLRrrCnDate;
      this.customerDetailsList.miscellaneousDetails.blAwbLRrrCnDate = this.datepipe.transform(
        this.customerDetailsList.miscellaneousDetails.blAwbLRrrCnDate,
        'dd/MM/yyyy'
      );
      this.customerDetailsList.miscellaneousDetails.lcDate = this.datepipe.transform(
        this.customerDetailsList.miscellaneousDetails.lcDate,
        'dd/MM/yyyy'
      );
      this.customerDetailsList.riskDetails.voyageExpectedDate = this.datepipe.transform(
        this.customerDetailsList.riskDetails.voyageExpectedDate,
        'dd/MM/yyyy'
      );
    }
    );
  }
  mapCoverages() {
    for (const coverage in this.customerDetailsList.coverages) {
      const coverageItem = Object.assign({}, this.coverageItem);
      switch (coverage) {
        case 'stfi': coverageItem.coverageName = 'STFI';
          coverageItem.sumInsured = this.customerDetailsList.coverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'earthquakeCoverage': coverageItem.coverageName = 'EarthQuake(Fire+Shock) coverage';
          coverageItem.sumInsured = this.customerDetailsList.coverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'addOnCoverages': this.mapAddOnCoverages();
      }
    }
  }

  mapAddOnCoverages() {
    for (const coverage in this.customerDetailsList.coverages.addOnCoverages) {
      const coverageItem = Object.assign({}, this.coverageItem);
      switch (coverage) {
        case 'terroismDamage': coverageItem.coverageName = 'Terrorism Damage';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'terroismForAddOnCover': coverageItem.coverageName = 'Terrorism for Addon Cover';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'forestFire': coverageItem.coverageName = 'Forest Fire';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'architectsSurveyorsEngineersFee': coverageItem.coverageName = 'Architects, Surveyors and Consulting Engineers Fees ( in excess of 3% claim amount)';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'removalOfDebris': coverageItem.coverageName = 'Removal of Debris (in excess of 1% claim amount)';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'impactDamageDueToInsuredOwnRailRoadVehicles': coverageItem.coverageName =
          'Impact Damage due to Insured\'s own Rail/Road Vehicles, Fork lifts, Cranes, Stackers and the like and articles dropped therefrom';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage]['impactDamagesuminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'omissionToInsureAdditions': coverageItem.coverageName = 'Omission to Insure additions, alterations or extensions';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'lossOfRentClause': coverageItem.coverageName = 'Loss Of Rent clause';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'Amount'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          coverageItem.indemnityPeriod = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'Months'];
          this.coveragesList.push(coverageItem);
          break;
        case 'insuranceOfAdditionalExpensesOfRentForAnAlternativeAccommodation':
          coverageItem.coverageName = 'Insurance Of Additional Expenses of  Rent For An Alternative Accommodation';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage]['insuranceOfAdditionalExpensesOfRentAmount'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          coverageItem.indemnityPeriod = this.customerDetailsList.coverages.addOnCoverages[coverage]['insuranceOfAdditionalExpensesOfRentMonths'];
          this.coveragesList.push(coverageItem);
          break;
      }
    }
  }
  mapPremiumBreakUpForAddonCovers(premiumData) {

    for (const coverage of premiumData.BlockCovers) {
      switch (coverage.coverName) {
        case 'Terrorism Cover': this.premiumBreakUpAddonCovglist[0][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Addon Terrorism Cover': this.premiumBreakUpAddonCovglist[1][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Forest Fire': this.premiumBreakUpAddonCovglist[2][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Architects  Surveyors and Consulting Engineers Fees': this.premiumBreakUpAddonCovglist[3][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Loss  of Rent Clause': this.premiumBreakUpAddonCovglist[4][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Insurance  of Additional Expenses of rent for an alternative accommodation': this.premiumBreakUpAddonCovglist[5][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Removal  of Debris': this.premiumBreakUpAddonCovglist[6][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'STFI': this.premiumBreakUpBasicCovglist[1][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Earthquake': this.premiumBreakUpBasicCovglist[2][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
      }
    }
  }

  mapPremiumBreakUpForBasicCovers(premiumData) {
    if ('RiskCovers' in premiumData) {
      for (const coverage of premiumData.RiskCovers) {
        switch (coverage.coverName) {
          case 'Basic Cover For Fire': this.premiumBreakUpBasicCovglist[0][1] = parseFloat(coverage.coverPremium).toFixed(2);
            break;
          case 'Impact Damage due to Insureds own Rail or Road Vehicles Forklifts Cranes Stackers and the like': this.premiumBreakUpAddonCovglist[7][1] = parseFloat(coverage.coverPremium).toFixed(2);
            break;
          case 'Omission to Insure additions alteration or extensions': this.premiumBreakUpAddonCovglist[8][1] = parseFloat(coverage.coverPremium).toFixed(2);
            break;
        }
      }
    }
    this.premiumBreakUpBasicCovglist[0][1] = parseFloat(premiumData.basicPremium).toFixed(2);
    //console.log(this.premiumBreakUpBasicCovglist);
    //console.log(this.premiumBreakUpAddonCovglist);
  }
  getNumberInDecimal(value) {
    return parseFloat(value).toFixed(2);
  }
  gettoken() {
    this.commonService.getToken().subscribe(
      (res) => {
        this.token = res;
        this.customerProposal();
      },
      (error: HttpErrorResponse) => {
        this.customerProposal();
      }
    );
  }

  rejectProposalButton() {
    this.isCustomerRejectionCommentsInvalid = false;
  }

  rejectProposal() {

    if (this.customerProposalTotalResponse.status == 'Rejected by Customer') {
      this.ifProposalRejected = true;
    } else {
      if (this.customerRejectCommentsDetails.comment == '') {
        this.isCustomerRejectionCommentsInvalid = true;
        return;
      }

      this.rejectCustomerProposal.customerName = this.customerDetailsList.customerDetails.nameOfCorporate;
      this.rejectCustomerProposal.customerLastName = this.customerDetailsList.customerDetails.nameOfCorporate;
      this.rejectCustomerProposal.proposalNo = this.customerProposalTotalResponse.proposalNumber;
      if (this.customerDetailsList.intermediaryDetails.salutation == '') {
        this.rejectCustomerProposal.salutation = 'MR';
      } else {
        this.rejectCustomerProposal.salutation = this.customerDetailsList.intermediaryDetails.salutation;
      }
      this.rejectCustomerProposal.partnerMobileNumber = this.customerDetailsList.intermediaryDetails.mobileNumber;
      this.rejectCustomerProposal.productName = this.customerDetailsList.product;
      this.rejectCustomerProposal.productId = this.customerDetailsList.ProductCode;
      this.rejectCustomerProposal.status = 'Rejected by Customer';
      this.rejectCustomerProposal.intermediaryID = this.customerDetailsList.intermediaryDetails.IntermediaryID;
      this.rejectCustomerProposal.partnerLastName = this.customerDetailsList.intermediaryDetails.firstName;
      this.rejectCustomerProposal.partnerEmail = this.customerDetailsList.intermediaryDetails.emailId;
      this.customerRejectCommentsDetails.createdBy = this.rejectCustomerProposal.customerName;
      this.customerRejectCommentsDetails.userCode = this.customerDetailsList.customerDetails.customerID;
      this.rejectCustomerProposal.endorsmentNumber = this.customerProposalTotalResponse.endorsmentNumber;
      this.rejectCustomerProposal.modeofOperation = this.customerDetailsList.ModeOfOperation;

      this.customerRejectCommentsDetails.time = formatDate(new Date(), 'dd/MM/yyyy h:mm:ss a', 'en-us');
      this.rejectCustomerProposal.custCommentsDetails.push(this.customerRejectCommentsDetails);

      this.commonService.rejectCustomerProposal(this.rejectCustomerProposal).subscribe(success => {
        this.ifProposalRejected = true;
        $('#RejectProposal').modal('hide');
      },
        error => {
        }
      );
    }
  }

  acceptedProposal() {
    this.emptyFieldError = false;
    if (this.customerDetailsForValidateOtpParams.otp == '') {
      this.emptyFieldError = true;
    } else {
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID;
      this.customerDetailsForValidateOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForValidateOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForValidateOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForValidateOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForValidateOtpParams.productId = this.customerDetailsList.ProductCode;
      this.customerDetailsForValidateOtpParams.productName = this.customerDetailsList.product;
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForValidateOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }

      this.notifyService.showError('GC Service Not Available', '');
      // this.customerProposalService.validateOtpForMarineCustomerproposalAcceptance(this.customerDetailsForValidateOtpParams).subscribe((res) => {
      //   switch (res) {
      //     case 'OTP Valid': this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
      //       this.isPaymentByAgentBehalfIndicator = res;
      //       $('#AcceptProposal').modal('hide');
      //       this.ifProposalAccepted = true;
      //     });
      //       break;
      //     case 'OTP Invalid': this.isOTPInvalid = true;
      //       this.isOTPTimedOut = false;
      //       break;
      //     case 'OTP Expired': this.isOTPTimedOut = true;
      //       this.isOTPInvalid = false;
      //       break;
      //   }
      // });
    }
  }

  convertNumberToINR(numToInr) {
    return this.commonMethodService.formatNumberToINR(numToInr);
  }


  editCustomerproposal() {
    this.selectedEndorsementType();
    this.getMasterDataForQuote(this.productCode);
    this.tooltipInit();
    setTimeout(() => {
      this.tooltipInit();
    }, 3000);
    this.customerProposalService.getMarineCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
      this.customerProposalEditParams = res.inputRequest;
      //console.log(this.customerProposalEditParams)
      this.customerProposalEditParams.sumInsured = this.commonMethodService.formatNumberToINR(this.customerProposalEditParams.sumInsured);
      this.customerProposalList.proposalNumber = res.proposalNumber;
      this.customerProposalRateList = res;
      this.policyStartDate = this.customerProposalRateList.inputRequest.policyStartDate;
      this.policyStartDate = this.policyStartDate.substring(6) + '-' + this.policyStartDate.substring(3, 5) + '-' + this.policyStartDate.substring(0, 2);
      this.policyEndDate = this.customerProposalRateList.inputRequest.policyEndDate;
      this.policyEndDate = this.policyEndDate.substring(6) + '-' + this.policyEndDate.substring(3, 5) + '-' + this.policyEndDate.substring(0, 2);
      this.isEditCustomerProposal = true;
      // this.customerProposalEditParams.riskDetails.voyageExpectedDate = this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(6) + '-' + this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(3, 5) + '-' + this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(0, 2);

      this.customerTypeMapping();
      //   this.customerTypeReMapping();
      this.DateofBirthEditProposal = this.customerProposalRateList.inputRequest.customerDetails.dateOfBirth;
      this.DateofBirthEditProposal = this.DateofBirthEditProposal.substring(6) + '-' + this.DateofBirthEditProposal.substring(3, 5) + '-' + this.DateofBirthEditProposal.substring(0, 2);
      this.financierList = res.inputRequest.financier.financierDetails;
      this.invoiceList = res.inputRequest.InvoiceDetails;
      this.customer = res.inputRequest.customerDetails.customerType;
    });
  }
  removeFinancier(financierIndex) {
    if (financierIndex !== 0) {
      this.financierList.splice(financierIndex, 1);
    }
    else {
      this.notifyService.showError('At least one record of Financier is required.', '')
    }
  }
  addAnotherFinancier() {
    let temp: any = {};
    this.financierList.push(temp);
  }


  makePayment() {
    this.isCustomerProposalMakePayment = true;
    this.inputForPayment.paymentDetails.amount = this.customerProposalTotalResponse.brmsResponse.totalPremium;
    this.inputForPayment.paymentDetails.emailAddress = this.customerDetailsList.customerDetails.emailId;
    this.inputForPayment.paymentDetails.firstName = this.customerDetailsList.customerDetails.nameOfCorporate;
    this.inputForPayment.paymentDetails.phoneNumber = this.customerDetailsList.customerDetails.mobileNumber.toString();
    this.inputForPayment.paymentDetails.proposalNo = localStorage.getItem('ProposalNumber');
    this.inputForPayment.paymentDetails.productInfo = this.customerDetailsList.product;
    this.paymentService.getTransactionId().subscribe(
      (res) => {
        this.inputForPayment.paymentDetails.transactionId = res.toString();
        this.createQuoteService.makePayment(this.inputForPayment).subscribe(
          (res) => {
            const myWindow = window.open('', '_self');
            myWindow.document.write(res);
          },
          (error: HttpErrorResponse) => {
          }
        );
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  NumberOnlyInput(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onCheckTerms() {
    this.isCheckSelected = !this.isCheckSelected;
  }

  getOtpForProposalAcceptance() {
    if (this.isCheckSelected == true) {
      this.customerDetailsForValidateOtpParams.otp = '';
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID;
      this.customerDetailsForGetOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForGetOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForGetOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForGetOtpParams.emailId = this.customerDetailsList.customerDetails.emailId;
      this.customerDetailsForGetOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForGetOtpParams.productId = this.customerDetailsList.ProductCode;
      this.customerDetailsForGetOtpParams.productName = this.customerDetailsList.product;
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForGetOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }

      this.customerProposalService.getOtpForMarineCustomerproposalAcceptance(this.customerDetailsForGetOtpParams).subscribe((res) => {
        this.acceptProposalOtpResponse = res;
      });
    } else {
      this.notifyService.showInfo('Please confirm the declaration before accepting the proposal', 'Customer Profile Notification');
    }
  }

  updateTransactionDetailsAfterPayment() {
    this.proposalsToPolicyParams.proposalNos.push(localStorage.getItem('gc_proposalNo'));
    this.proposalsToPolicyParams.partnerproposalNos.push(localStorage.getItem('ProposalNumber'));
    this.proposalsToPolicyParams.officeCode = null;
    this.proposalsToPolicyParams.paymentBy = 'CUSTOMER';
    this.proposalsToPolicyParams.transactionDetails.amount = this.paymentResponse.amount;
    this.proposalsToPolicyParams.transactionDetails.email = this.paymentResponse.email;
    this.proposalsToPolicyParams.transactionDetails.error = this.paymentResponse.error;
    this.proposalsToPolicyParams.transactionDetails.hashCode = this.paymentResponse.hash;
    this.proposalsToPolicyParams.transactionDetails.mId = this.paymentResponse.mihpayid;
    this.proposalsToPolicyParams.transactionDetails.mode = this.paymentResponse.mode;
    this.proposalsToPolicyParams.transactionDetails.payerCustomerId = localStorage.getItem('CustomerID');
    this.proposalsToPolicyParams.transactionDetails.pgType = this.paymentResponse.PG_TYPE;
    this.proposalsToPolicyParams.transactionDetails.status = this.paymentResponse.status;
    this.proposalsToPolicyParams.transactionDetails.transactionId = this.paymentResponse.txnid;
    this.proposalsToPolicyParams.transactionDetails.unmappedStatus = this.paymentResponse.unmappedstatus;
    if (this.proposalsToPolicyParams.transactionDetails.status == 'success') {
      this.isCustomerProposalMakePaymentSuccess = true;
      this.notifyService.showSuccess('Payment has been completed successfully, policy details will be shared soon', 'Payment Notification');
      this.commonService.getToken().subscribe(
        (token) => {
          this.proposalsToPolicyParams.tokenId = token;
          this.commonService.convertProposalToPolicyOnPaymentSuccess(this.proposalsToPolicyParams).subscribe(paymentres => {
            this.notifyService.showSuccess(paymentres + '.', 'Policy Notification');
          });
        });
    }
  }
  // onChangeCustomerType(customerType) {
  //   if (customerType == 'I') {
  //     this.commonService.getSalutation('Individual').subscribe(res => {
  //       this.salutationList = res;
  //       this.salutationList = this.salutationList.keyValuePairList.keyValuePairList;
  //     });
  //   } else {
  //     this.salutationList = [{
  //       name: 'No Options For selected Customer Type'
  //     }
  //     ];
  //   }
  // }
  onChangeCustomerType(customerType) {
    if (customerType == 'I') {
      this.isCustomerTypeInvalid = false;
      this.commonService.getSalutation('Individual').subscribe(res => {
        this.salutationList = res;
        this.salutationList = this.salutationList.keyValuePairList.keyValuePairList;
        this.customerProposalEditParams.customerDetails.salutation = '';
      });
    } else if (customerType == 'C') {
      //   // this.isCustomerTypeInvalid = true;
      this.salutationList = [{
        name: 'M/S'
      }
      ];
      this.customerProposalEditParams.customerDetails.salutation = 'M/S';

    }
  }
  getCustomerTypeList() {
    this.commonService.getCustomerType().subscribe(res => {
      this.customerTypeList = res;
    });
  }
  CancelEditButton() {
    this.isEditCustomerProposal = false;
    this.isCheckSelected = false;
    setTimeout(() => {
      this.tooltipInit();
    }, 1000);
  }
  getMasterDataForQuote(productCode) {
    this.newQuoteService.getMasterDataForQuote(productCode).subscribe((res) => {
      this.masterDataForQuote = res;
    });
  }
  agreementTypeData() {
    this.commonService.agreementTypeData().subscribe(res => {
      this.agreementData = res;
    });
  }
  saveEditCustomerProposal() {
    // if (this.customerProposalEditParams.InputXML.typeOfBusiness == 'Roll Over' ? this.PreviousPolicyDetailsComponent.isfromValid() : true) {
    //   this.submitted = true;
    // if (this.customerProposalEditParams.InputXML.typeOfBusiness == 'Roll Over') {
    //   this.customerProposalEditParams.InputXML.PASTPOLICY['PASTPOLICYDETAILS'] = JSON.parse(JSON.stringify(this.PreviousPolicyDetailsComponent.prevPolicyList));
    //   this.customerProposalEditParams.InputXML.PASTPOLICY['PASTPOLICYDETAILS'].forEach(item => {
    //     const policyStartYear = parseFloat(item.PreviousPolicyStartdate.toString().substring(0, 4));
    //     const policyStartMonth = parseFloat(item.PreviousPolicyStartdate.toString().substring(5, 7));
    //     const policyStartDate = parseFloat(item.PreviousPolicyStartdate.toString().substring(8));
    //     const startDate = new Date(policyStartYear, policyStartMonth - 1, policyStartDate);
    //     item.PreviousPolicyStartdate = this.datepipe.transform(
    //       startDate,
    //       'dd/MM/yyyy'
    //     );
    //     const policyEndYear = parseFloat(item.PreviousPolicyEnddate.toString().substring(0, 4));
    //     const policyEndMonth = parseFloat(item.PreviousPolicyEnddate.toString().substring(5, 7));
    //     const policyEndDate = parseFloat(item.PreviousPolicyEnddate.toString().substring(8));
    //     const endDate = new Date(policyEndYear, policyEndMonth - 1, policyEndDate);
    //     item.PreviousPolicyEnddate = this.datepipe.transform(
    //       endDate,
    //       'dd/MM/yyyy'
    //     );
    //   });
    // }
    //this.financierDetailsComponent.validateFinanceirDetailsForm(true);
    // if (this.financierDetailsFormValid) {
    //   this.customerProposalEditParams.InputXML['ProposalNumber'] = this.customerProposalList.proposalNumber;
    //   this.customerProposalEditParams.InputXML['policyStartDate'] = this.policyStartDate;
    //   this.customerProposalEditParams.InputXML['policyStartDate'] = this.datepipe.transform(
    //     this.customerProposalEditParams.InputXML['policyStartDate'],
    //     'dd/MM/yyyy'
    //   );
    //   this.customerProposalEditParams.InputXML['customerDetails']['dateOfBirth'] = this.DateofBirthEditProposal;
    //   this.customerProposalEditParams.InputXML['customerDetails']['dateOfBirth'] = this.datepipe.transform(
    //     this.customerProposalEditParams.InputXML['customerDetails']['dateOfBirth'],
    //     'dd/MM/yyyy'
    //   );
    // this.customerProposalEditParams.InputXML.sumInsured = this.commonMethodService.convertToPureNumber(this.customerProposalEditParams.InputXML.sumInsured)
    this.customerProposalEditParams.ProposalNumber = this.customerProposalTotalResponse.proposalNumber;
    this.customerProposalService.saveMarineEditCustomerProposalDetails(this.customerProposalEditParams)
      .subscribe(
        res => {
          this.isEditCustomerProposal = false;
          this.isCheckSelected = false;
          this.customerProposalService.getMarineCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
            this.customerDetailsList = res.inputRequest;
            this.customerProposalTotalResponse = res;
            this.customerDetailsList.riskDetails.voyageExpectedDate = this.datepipe.transform(
              this.customerDetailsList.riskDetails.voyageExpectedDate,
              'dd/MM/yyyy'
            );
            this.notifyService.showSuccess('Customer Profile updated successfully', 'Customer Profile Notification');
          }
          );
          setTimeout(() => {
            this.tooltipInit();
          }, 1000);

          setTimeout(() => {
            this.tooltipInit();
          }, 4000);
        }
      );
  }

  customerTypeReMapping() {
    this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] = this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'].toUpperCase();
    if (this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] == 'INDIVIDUAL') {
      this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] = 'Individual';
      this.onChangeCustomerType('I');
    } else if (this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] == 'CORPORATE') {
      this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] = 'C';
      this.onChangeCustomerType('C');
    } else if (this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] == 'GOVT.UNDERTAKING') {
      this.customerProposalRateList.inputRequest.InputXML.customerDetails['customerType'] = 'G';
      this.onChangeCustomerType('G');
    }
    this.customerProposalRateList.inputRequest.InputXML.customerDetails['salutation'] = this.customerProposalRateList.inputRequest.InputXML.customerDetails['salutation'].toUpperCase();
  }
  customerTypeMappingForMarine() {
    if (this.customerDetailsList.customerDetails['customerType'] == 'I') {
      this.customerDetailsList.customerDetails['customerType'] = 'Individual';
    } else if (this.customerDetailsList.customerDetails['customerType'] == 'C') {
      this.customerDetailsList.customerDetails['customerType'] = 'CCORPORATE';
    } else if (this.customerDetailsList.customerDetails['customerType'] == 'G') {
      this.customerDetailsList.customerDetails['customerType'] = 'GOVT.UNDERTAKING';
    }
  }
  onKeyUpValidationForField(fieldName) {
    switch (fieldName) {
      case 'dob':
        if ((new Date().getFullYear() - new Date(this.DateofBirthEditProposal).getFullYear()) < 18) {
          this.isDobInvalid = true;
        } else {
          this.isDobInvalid = false;
        }
        break;
      case 'dobFuture':
        if (
          (new Date(this.DateofBirthEditProposal)) > (new Date(this.getToday()))
        ) {
          this.dobFutureDate = true;
        } else {
          this.dobFutureDate = false;
        }
        break;
      case 'policyDate':
        if ((new Date(this.policyStartDate)) < (new Date(this.getToday()))
        ) {
          this.isPolicyStartDate = true;
        } else {
          this.isPolicyStartDate = false;
        }
        break;
      case 'emailId':
        const pattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        const inputString = this.customerProposalEditParams.InputXML['customerDetails']['emailId'];
        if (pattern.test(inputString)) {
          this.isEmailIdInValid = false;
        } else {
          this.isEmailIdInValid = true;
        }
        break;
      case 'alternateEmailId':
        const patternAl = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        const inputStringAl = this.customerProposalEditParams.InputXML['customerDetails']['alternateEmailId'];
        if (patternAl.test(inputStringAl)) {
          this.isAlEmailIdInValid = false;
        } else {
          this.isAlEmailIdInValid = true;
        }
        break;
      case 'mobileNumber1':
        const patternmb1 = /^[6-9.][0-9]{9}$/;
        const inputStringmb1 = this.customerProposalEditParams.InputXML['customerDetails']['mobileNumber'];
        if (patternmb1.test(inputStringmb1)) {
          this.isMobilenumberInValid = false;
        } else {
          this.isMobilenumberInValid = true;
        }
        break;
      case 'mobileNumber2':
        const patternmb2 = /^[6-9.][0-9]{9}$/;
        const inputStringmb2 = this.customerProposalEditParams.InputXML['customerDetails']['alternateMobileNumber'];
        if (patternmb2.test(inputStringmb2)) {
          this.isMobilenumber2InValid = false;
        } else {
          this.isMobilenumber2InValid = true;
        }
        break;
      default:
        break;
    }
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  getToolTipMsgFor(toolTipFor) {
    switch (toolTipFor) {
      case 'Terrorism Damage': return '“Terrorism damage” is terrorism cover for basic coverage';
        break;
      case 'Terrorism for Addon Cover': return '“Terrorism for add on” is terrorism cover for add on covers';
        break;
      case 'Architects, Surveyors and Consulting Engineers Fees ( in excess of 3% claim amount)':
        return 'The expenses incurred on the fee of mentioned professionals in case of damage by Insured peril is covered by this add-on.';
        break;
      case 'Removal of Debris (in excess of 1% claim amount)':
        return 'Cost incurred to remove debris followed by damage by Insured Perils is covered by this add-on.';
        break;
      case 'Omission to Insure additions, alterations or extensions':
        return 'This add on provides protection for any addition, alternation or extension' +
          ' to the existing property (other than stocks) that the Insured erect or add during the currency of policy at covered risk location.';
        break;
      case 'Loss Of Rent clause':
        return 'Loss of Rent covers the loss of income in the form of rent receivable when the insured property has been rented out and it becomes uninhabitable due to occurrence of an Insured Event.';
        break;
      case 'Insurance Of Additional Expenses of  Rent For An Alternative Accommodation':
        return 'Covers the additional cost for an alternate accommodation which the insured may incur in case the occupied property becomes uninhabitable due to occurrence of an Insured Peril.';
        break;
      default: return null;
        break;
    }
  }
  selectPincode(item) {
    this.isPinCodeInvalid = false;
    this.newQuoteService.getPincodeDataOnSelect(item).subscribe(res => {
      if (Object.keys(res).length != 0) {
        this.customerProposalEditParams.mailingAddress['mailingPinCode'] = item;
        this.PincodeMasterData = res;
        this.customerProposalEditParams['mailingAddress']['mailingDistrict'] = this.PincodeMasterData.cityDistrictName;
        this.customerProposalEditParams['mailingAddress']['mailingDistrictCd'] = this.PincodeMasterData.cityDistrictCode;
        this.customerProposalEditParams['mailingAddress']['mailingState'] = this.PincodeMasterData.stateName;
        this.customerProposalEditParams['mailingAddress']['mailingStateCd'] = this.PincodeMasterData.stateCode;
        this.customerProposalEditParams['mailingAddress']['mailingTownOrCity'] = this.PincodeMasterData.cityDistrictName;
        this.customerProposalEditParams.LocationID = this.PincodeMasterData.locationCode;
      } else {
        this.pinCodeSearchCleared();
      }
    });
  }
  requestAgentPayment() {
    this.customerProposalService.requestAgentToMakePayment(this.tempProposalNumber).subscribe((res: any) => {
      this.ifRequestAgentToPayment = true;
    }
    );
  }

  onChangePincodeData(val: string) {
    this.isPinCodeInvalid = true;
    if (val.trim() != '') {
      this.promise = new Promise<void>((resolve, reject) => {
        this.newQuoteService.getPincodeMasterData(val)
          .toPromise()
          .then(
            res => {
              this.PinCodeList = res;
              if (this.PinCodeList.length == 0) {
                this.pinCodeSearchCleared();
              }
              resolve();
            }
          );
      });
    }
    return this.promise;
  }
  pinCodeSearchCleared() {
    this.PincodeMasterData = null;
    this.PinCodeList = null;
    this.isPinCodeInvalid = false;
  }
  uploadedDocumentCount = 0;
  uploadedDocumentList;
  docDataSet = {};
  uploadedFilesList = [];
  prepareUploadedFileData() {
    const uniqueDocTypeList = [];
    if (this.uploadedDocumentCount > 0) {
      this.uploadedDocumentList.forEach(docData => {
        if (!(uniqueDocTypeList.indexOf(docData.docType) > -1)) {
          uniqueDocTypeList.push(docData.docType);
        }
      });
      for (const docType of uniqueDocTypeList) {
        this.docDataSet[docType] = this.uploadedDocumentList.filter(docData => docData.docType == docType);
      }
      for (const docType in this.docDataSet) {
        const docListObj = new UploadedFileObj();
        docListObj.docName = docType;
        let temp = [];
        temp = this.docDataSet[docType];
        docListObj.docsCount = temp.length;
        if (docListObj.docsCount == 1) {
          docListObj.docRealFileName = temp[0].actualFileName;
        }
        temp.forEach((doc, index, temp) => {

          if ('docComment' in doc) {
            if (doc['docComment'] != '') {
              docListObj.comments = docListObj.comments + doc['docComment'] + ';';
            }
          }
          if (index == 0) {
            docListObj.lastUploadedBy = doc['uploadedby'];
            docListObj.lastUploadedDate = doc['date'];
            if (temp.length == 1) {
              docListObj.uuid = doc['uuid'];
            }
          } else {
            if (new Date(docListObj.lastUploadedDate) < new Date(doc['date'])) {
              docListObj.lastUploadedDate = doc['date'];
              docListObj.lastUploadedBy = doc['uploadedby'];
            }
          }
        });
        this.uploadedFilesList.push(docListObj);
      }
    }
  }


  getUploadedDocuments(proposalNumber) {
    this.newProposalService.getUploadedDocuments(proposalNumber).subscribe(res => {
      this.uploadedDocumentList = res;
      this.uploadedDocumentCount = this.uploadedDocumentList != null ? this.uploadedDocumentList.length : 0;
      this.prepareUploadedFileData();
    });
  }

  formatdocName(docName) {
    return docName.replace(/_/g, ' ');
  }

  downloadAll() {
    if (this.uploadedDocumentCount > 1) {
      this.newProposalService.getAllDocumentZip(this.proposalInput.proposalNumber).subscribe(res => {
        this.loaderService.show();
        setTimeout(() => {
          this.downloadZIPBase64File(this.proposalInput.proposalNumber + 'All_Files', res['base64String']);
          this.loaderService.hide();
        }, 10000);
      });
    } else {
      if (this.uploadedDocumentCount == 1) {
        this.newProposalService.getAllDocumentZip(this.proposalInput.proposalNumber).subscribe(res => {
          this.loaderService.show();
          setTimeout(() => {
            this.downloadAnyBase64File(res['mimeType'], res['base64String'], res['docType']);
            this.loaderService.hide();
          }, 10000);
        });
      }
    }
  }


  downloadFile(documentCount, uuid, fileType, docRealName) {
    if (documentCount == 1) {
      this.newProposalService.getDocumentByUUID(uuid).subscribe(res => {
        if (res['mimeType'] == '') {
          res['mimeType'] = res['physicalFileName'].substring(res['physicalFileName'].lastIndexOf('.') + 1);
          switch (res['mimeType']) {
            case 'xlsx':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              break;
            case 'xls':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/vnd.ms-excel';
              break;
            case 'doc':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/msword';
              break;
            case 'docx':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/vnd.openxmlformats-officedocument.wordprocessingm';
              break;
            default:
              break;
          }
        }
        this.downloadAnyBase64File(res['mimeType'], res['base64String'], docRealName);
      });
    } else {
      if (documentCount > 1) {
        this.newProposalService.getDocSetZip(this.proposalInput.proposalNumber, fileType).subscribe(res => {
          this.loaderService.show();
          setTimeout(() => {
            this.downloadZIPBase64File(fileType, res['base64String']);
            this.loaderService.hide();
          }, 10000);
        });
      }
    }
  }

  public async downloadZIPBase64File(filename: string, content: string) {
    const zip = new JSZip();
    await zip.loadAsync(content, { base64: true });
    const blob = await zip.generateAsync({ type: "blob" });

    const element = document.createElement("a");
    element.setAttribute("href", window.URL.createObjectURL(blob));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  downloadAnyBase64File(contentType, base64Data, fileName) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  selectedEndorsementType() {


    if (this.customerProposalTotalResponse.status == 'EN Pending Consent') {
      this.disableAllEn = true;

      this.customerDetailsList.EndorsementTypes.forEach(endorsementType => {
        this.isInclusionofFinancierChecked = (endorsementType == 'Inclusion of Financier') ?
          false : (endorsementType == 'Inclusion  of Financier') ? true : this.isInclusionofFinancierChecked;
        this.isAnyOtherNilEndorsementChecked = (endorsementType == 'Any Other Nil Endorsement') ?
          false : (endorsementType == 'Any Other Nil Endorsement') ? true : this.isAnyOtherNilEndorsementChecked;
        this.isChangeinClientDetailsChecked = (endorsementType == 'Change in Client Details') ?
          false : (endorsementType == 'Change in Client Details') ? true : this.isChangeinClientDetailsChecked;

      });


    }
  }

  deleteInvoice(item) {
    const index: number = this.invoiceList.indexOf(item);
    if (index !== 0) {
      this.invoiceList.splice(index, 1);
    }
    else {
      this.notifyService.showError('At least one record of Invoice is required.', '')
    }
  }
  addAnotherInvoice() {
    let temp: any = {};
    this.invoiceList.push(temp);
  }
  onVoyageTypeChange(event) {
    //console.log(event);
    let tempaArr: any = ['Inland', 'Export:FOB/CFR', 'Export (other than EXW/FOB/CFR)'];
    let tempArr2: any = ["Cross Voyage (Mercantile Trade/Third country exports)", "Duty Only", "Import(other than CIF/CIP)", "(Import-CIF/CIP (Tail-end)"];
    let tempArr3: any = ["Inland", "Duty Only", "Import(other than CIF/CIP)", "(Import-CIF/CIP (Tail-end)"];
    if (tempaArr.indexOf(event) > -1) {
      this.customerProposalEditParams.voyageRoute.originatingCountry =
        this.masterDataForMarine.COUNTRY_TYPE.find(x => x.lookupValue === 'India').lookupValue;
    }
    if (tempArr3.indexOf(event) > -1) {
      this.customerProposalEditParams.voyageRoute.destinationCountey =
        this.masterDataForMarine.COUNTRY_TYPE.find(x => x.lookupValue === 'India').lookupValue;
    }
    if (tempArr2.indexOf(event) > -1) {
      this.customerProposalEditParams.voyageRoute.originatingCountry = '';
      this.customerProposalEditParams.voyageRoute.destinationCountey = '';
    }
    // by default invoice currency should be INR
    this.customerProposalEditParams.sumInsuredDetails.currencyOfInvoice = (event == 'Inland') ?
      this.masterDataForMarine.CURRENCY_TYPE.find(x => x.lookupDescription === 'Indian rupee').lookupValue : '';
    this.customerProposalEditParams.sumInsuredDetails.exchangeRate = (event == 'Inland') ? 1 : '';
  }
  getMasterDataForMarine() {
    this.lineOfBusinessCode = "34";
    this.productCode = '3413';
    let imdcode = this.commonService.getUserName();
    let userRole = this.commonService.getUserRole();

    this.commonService.getMasterDataForMarine(this.lineOfBusinessCode, this.productCode, imdcode, userRole).subscribe((res) => {
      this.masterDataForMarine = res;
      //console.log(this.masterDataForMarine)

      // prepopulating type of packing to St and Customary
      // this.customerProposalEditParams.riskDetails.typeOfPacking =
      //   this.masterDataForMarine.TYPE_OF_PACKING.find(x => x.lookupDescription === 'St and customary').lookupValue;
      // by default type of business should be new business and not editable for marine quote
      this.customerProposalEditParams.typeOfBusiness =
        this.masterDataForMarine.BUSINESS_TYPE.find(x => x.lookupDescription === 'New Business').lookupValue;
      this.masterDataForMarine.DEDUCTIBLE_TYPE.forEach(type => {
        if (type.lookupDescription == 'Claim Basis') this.customerProposalEditParams.deductibleDetails.deductibleType = type.lookupValue;
      })
    });
  }
  onOriginatingCountryChagned(event) {
    let tempArr2: any = ["Cross Voyage (Mercantile Trade/Third country exports)", "Duty Only", "Import(other than CIF/CIP)", "(Import-CIF/CIP (Tail-end)"];
    //console.log(this.customerProposalEditParams.riskDetails.voyageType);
    this.businessValidations.originatingCountry = ((event == 'India') && (tempArr2.indexOf(this.customerProposalEditParams.riskDetails.voyageType) > -1)) ? true : false;
  }
  onDestinationcountryChanged(event) {
    let tempArry: any = ['Cross Voyage (Mercantile Trade/Third country exports)', 'Export:FOB/CFR', 'Export (other than EXW/FOB/CFR)']
    this.businessValidations.destinationCountey = (event == 'India' && (tempArry.indexOf(this.customerProposalEditParams.riskDetails.voyageType) > -1)) ? true : false;
  }
  onAgreementTypeChange(financierDetail) {
    financierDetail.loanAccountNumber = '';
  }
  customerTypeMapping() {
    if (this.customerProposalEditParams.customerDetails.customerType == 'I') {
      this.customerProposalEditParams.customerDetails.customerType = 'INDIVIDUAL';
    } else if (this.customerProposalEditParams.customerDetails.customerType == 'C') {
      this.customerProposalEditParams.customerDetails.customerType = 'CORPORATE';
    } else if (this.customerProposalEditParams.customerDetails.customerType == 'G') {
      this.customerProposalEditParams.customerDetails.customerType = 'GOVT.UNDERTAKING';
    }
  }
  // getLOBs() {
  //   this.commonService.getLineofBusiness().subscribe((res) => {
  //     this.lobList = res;
  //     this.router.queryParams.subscribe(params => {
  //       if (Object.keys(params).length != 0) {
  //         this.lineOfBusinessCode = params.lob;
  //         this.productCode = params.product;
  //         this.getMasterDataForMarine();
  //         this.lobAndProductList = this.lobList.find((lob) => lob.lobCode == this.lineOfBusinessCode);
  //       }
  //     });
  //   });
  // }

}

